import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { initTheme } from './utils/theme';
import { initProjectTheme } from './utils/projectTheme';
import { initAppInsights } from './utils/appInsights';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { setAdminMsalInstance } from './utils/axiosAdminApiInstance';

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

initTheme();
initAppInsights();
initProjectTheme();

msalInstance.initialize().then(() => {
  setAdminMsalInstance(msalInstance);
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});

reportWebVitals();
